export const locale = {
    lang: "pt-BR",
    data: {
        DIALOG: {
            CONFIRM: "OK",
            CANCEL: "CANCELAR",
            DESC: "Digite a frase a seguir para confirmar: ",
            CONFIRMATION: "excluir permanentemente",
            KNOW_MORE: "SAIBA MAIS",
            NO: "NÃO",
            YES: "SIM"
        }
    }
};
